"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmptyBodyGraphqlError = void 0;
var _axios = require("@ori/axios");
var _GraphqlError = require("./GraphqlError");
/**
 * Error that indicates that fetch to graphql server was successful, but had empty response
 */ var EmptyBodyGraphqlError = /*#__PURE__*/ function(_GraphqlError_GraphqlError) {
    _inherits(EmptyBodyGraphqlError, _GraphqlError_GraphqlError);
    function EmptyBodyGraphqlError(response) {
        _class_call_check(this, EmptyBodyGraphqlError);
        var _this;
        var message = 'Empty body returned from GraphQl server';
        // eslint-disable-next-line unicorn/custom-error-definition -- okay in this case
        _this = _call_super(this, EmptyBodyGraphqlError, [
            new _axios.AxiosError(message, _axios.AxiosError.ERR_BAD_RESPONSE, response.config, response.request, response)
        ]);
        _this.name = 'EmptyBodyGraphqlError';
        _this.message = message;
        return _this;
    }
    return EmptyBodyGraphqlError;
}(_GraphqlError.GraphqlError);
exports.EmptyBodyGraphqlError = EmptyBodyGraphqlError; //# sourceMappingURL=EmptyBodyGraphqlError.js.map
